import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Users, RefreshCw, Phone, Mail, Calendar, Trash2 } from 'lucide-react';

function api(method, url, data = null, config = {}) {
  const pw = sessionStorage.getItem('admin_password');
  return axios({ method, url, data, ...config, headers: { 'x-adminpassword': pw } });
}

export default function AdminClients() {
  const [clients, setClients] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    api('get', '/api/admin/clients')
      .then(r => setClients(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  const formatDate = (d) => {
    if (!d) return '—';
    const [y, m, day] = d.split('-');
    return `${day}/${m}/${y}`;
  };

  const filtered = clients.filter(c =>
    c.client_name.toLowerCase().includes(search.toLowerCase()) ||
    c.client_phone.includes(search)
  );

  const remove = async (phone, name) => {
    if (!window.confirm(`Remover o cliente "${name}"?\nIsso apagará todos os agendamentos deste cliente.\nEsta ação não pode ser desfeita.`)) return;
    await api('delete', `/api/admin/clients/${encodeURIComponent(phone)}`);
    load();
  };

  const initials = (name) =>
    name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase();

  const colors = ['linear-gradient(135deg,#c9a96e,#a07840)', 'linear-gradient(135deg,#9b59b6,#7d3c98)', 'linear-gradient(135deg,#2d8c4e,#1e6b38)', 'linear-gradient(135deg,#2980b9,#1a5276)', 'linear-gradient(135deg,#e74c3c,#c0392b)'];

  return (
    <div className="admin-section">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '1rem' }}>
        <h2 className="admin-section-title" style={{ marginBottom: 0 }}>
          Clientes <span style={{ fontSize: '1rem', color: 'var(--text-gray)', fontFamily: 'Poppins' }}>({clients.length})</span>
        </h2>
        <button className="btn-primary" style={{ fontSize: '0.85rem', padding: '0.6rem 1.2rem', display: 'flex', alignItems: 'center', gap: '0.4rem' }} onClick={load}>
          <RefreshCw size={15} /> Atualizar
        </button>
      </div>

      <div className="admin-filters">
        <input
          type="text"
          placeholder="Buscar por nome ou telefone..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ minWidth: '260px' }}
        />
        <span style={{ fontSize: '0.82rem', color: 'var(--text-gray)', marginLeft: 'auto' }}>
          {filtered.length} cliente(s)
        </span>
      </div>

      <div className="admin-table-wrap">
        {loading ? (
          <div className="empty-state">Carregando...</div>
        ) : filtered.length === 0 ? (
          <div className="empty-state">
            <Users size={40} strokeWidth={1} style={{ color: 'var(--gold-light)', marginBottom: '0.75rem' }} />
            <p>Nenhum cliente encontrado.</p>
          </div>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>Cliente</th>
                <th>Telefone</th>
                <th>E-mail</th>
                <th>Total Visitas</th>
                <th>Última Visita</th>
                <th>Ação</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((c, idx) => (
                <tr key={c.client_phone}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                      <div
                        className="photo-initials"
                        style={{ background: colors[idx % colors.length], width: 38, height: 38, fontSize: '0.85rem', flexShrink: 0 }}
                      >
                        {initials(c.client_name)}
                      </div>
                      <strong>{c.client_name}</strong>
                    </div>
                  </td>
                  <td>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                      <Phone size={13} color="var(--gold)" /> {c.client_phone}
                    </span>
                  </td>
                  <td>
                    {c.client_email ? (
                      <span style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
                        <Mail size={13} color="var(--gold)" /> {c.client_email}
                      </span>
                    ) : <span style={{ color: '#bbb' }}>—</span>}
                  </td>
                  <td>
                    <span style={{
                      background: 'rgba(201,169,110,0.12)',
                      color: 'var(--gold-dark)',
                      padding: '0.2rem 0.75rem',
                      borderRadius: '50px',
                      fontWeight: 600,
                      fontSize: '0.85rem'
                    }}>
                      {c.total_bookings}x
                    </span>
                  </td>
                  <td>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '0.3rem', color: 'var(--text-gray)', fontSize: '0.85rem' }}>
                      <Calendar size={13} color="var(--gold)" /> {formatDate(c.last_booking)}
                    </span>
                  </td>
                  <td>
                    <button className="btn-icon" title="Remover cliente" onClick={() => remove(c.client_phone, c.client_name)}>
                      <Trash2 size={15} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
